import { KeywordLookupItem } from '../../../api/lookup/keyword-lookup-item';

export function buildLookupDropdownOptions(
  records: Record<string, unknown>[],
  combinationDisplayNames: string[],
  subFields: KeywordLookupItem[] = []
): { label: string; value: string; record: Record<string, unknown> }[] {
  return records
    .filter(r => r['RowId'] != null && r['RowId'] !== '')
    .map(record => ({
      label: formatLookupLabel(record, combinationDisplayNames, subFields),
      value: String(record['RowId']),
      record,
    }));
}

function formatLookupLabel(
  record: Record<string, unknown>,
  names: string[],
  subFields: KeywordLookupItem[]
): string {
  if (!names.length) {
    return String(record['RowId'] ?? '');
  }

  const parts = names
    .map(name => {
      const sub = subFields.find(f => f.displayName === name || f.key === name);
      const rawValue = name in record ? record[name] : (sub ? record[sub.key] : undefined);
      return resolveFieldDisplayValue(rawValue, sub);
    })
    .filter(v => v != null && v !== '');

  return parts.length ? parts.map(String).join(' - ') : String(record['RowId'] ?? '');
}

function resolveFieldDisplayValue(
  value: unknown,
  subField?: KeywordLookupItem
): unknown {
  if (value == null || value === '') {
    return value;
  }

  const options = subField?.options;
  if (!options?.length) {
    return value;
  }

  const option = options.find(
    opt => opt.key == value || String(opt.key) === String(value)
  );
  return option ? option.value : value;
}

export function isLookupDropdownSelected(instance: Record<string, unknown>, selectionKey?: string): boolean {
  if (selectionKey) {
    return instance[selectionKey] === true;
  }
  return instance['RowId'] != null && instance['RowId'] !== '';
}
